// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu_menuContainer__PXV5I","iconWrapper":"Menu_iconWrapper__sPgFj","active":"Menu_active__LsPUM","icon":"Menu_icon__EibIs"};